import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PriceModel } from './Price.model';
export class AdditionalFeeModel {
  constructor(additionalFeeModel) {
    _defineProperty(this, "price", void 0);
    _defineProperty(this, "code", void 0);
    _defineProperty(this, "name", void 0);
    this.price = additionalFeeModel.price;
    this.code = additionalFeeModel.code;
    this.name = additionalFeeModel.name;
  }
  static fromV1(additionalFee, modelContext) {
    return new AdditionalFeeModel({
      price: PriceModel.fromV1(additionalFee.price, modelContext),
      code: additionalFee.code,
      name: additionalFee.translatedName ?? additionalFee.name
    });
  }
}
//# sourceMappingURL=AdditionalFee.model.js.map